var $ = require('jquery');
var phpjs = require('./phpjs');

var Parameters = function() {

}

controlExtendedParameters();

/* show/hide parameters */
//Scroll to scrolling parameter
$('.parameter-scrolling').each(function (i, nodeDIV) {
    nodeDIV = $(nodeDIV);
    var nodeINPUT = nodeDIV.find('input[checked=checked]')[0];
    if (nodeINPUT.length) {
        var newScrollTop = parseInt(nodeINPUT.parents('li').attr('offsetTop')) - parseInt(nodeDIV.attr('offsetTop'));
        nodeDIV.attr('scrollTop', newScrollTop);
    }
});

$('.a_pokazat_vse').each(function (i, elA) {
    elA = $(elA);
    elA.on('click', function (e) {
        if ($(this).css('display') != 'none') {
            $(this).css('opacity', '1');
            $(this).hide(true);
            fnParametersPokazatVseClick($(this).attr('data-parameter_id'), 1);
        }
    });
});
$('.a_ochistit').on('click', function () {
    $('.widget.widget-slider.widget_product_params input:checked').each(function (i, el) {
        el = $(el);
        if (el[0].checked) {
            el.parents('label').detach('click');
            el.parents('label')[0].click();
            el[0].checked = false;
            el.parents('label').on('click', fnParametersOnClickLabel);
        }
        //                    el.next('span').css('color', '#000000');
    });
    if ($('.product-total-popup').length) {
        $('.product-total-popup').each(function (i, elDIV) {
            elDIV = $(elDIV);
            elDIV.hide();
        });
    }
    var category_id = $('#f_parameters').attr('data-category_id');
    var var_name_parameters_selected = 'parameters_selected_' + category_id;
    //                Y.Cookie.setSub(Y.MyApp.Inner.COOKIE_SUB_PARAMETERS,var_name_parameters_selected, 0);
    var parameters_selected_index = 0;
    var var_name_parameters_selected_element = var_name_parameters_selected + '[' + parameters_selected_index + ']';
    /*while (Y.Cookie.getSub(Y.MyApp.Inner.COOKIE_SUB_PARAMETERS, var_name_parameters_selected_element)) {
     Y.Cookie.removeSub(Y.MyApp.Inner.COOKIE_SUB_PARAMETERS, var_name_parameters_selected_element, null);
     parameters_selected_index++;
     var_name_parameters_selected_element = var_name_parameters_selected + '[' + parameters_selected_index + ']';
     }*/
    hideLayer($('#a_ochistit'));
    ajaxParametersCrossSample(null);
});

fnParametersApplyClickEventForBShowButton();
$('#f_parameters').on('submit', Parameters.prototype.fnParametersSubmit);
$('.widget.widget-slider.widget_product_params input').each(function (i, nodeInput) {
    nodeInput = $(nodeInput);
    fnParametersApplyEventNodeInputsClick(nodeInput);
});
ajaxParametersCrossSample(null);

// Parameters extended link
var nodeA = $('div.parameters-extended-link a');
if (nodeA.length) {
    nodeA.on('click', function (e) {
        fnParametersExtendedClick();
    });
    nodeA = $('div.parameters-extended-link-down a');
    nodeA.on('click', function (e) {
        fnParametersExtendedDownClick();
    });
}

controlExtendedParameters();

function controlExtendedParameters() {
    var
        showLink = $('#show_extended_parameters'),
        hideLink = $('#hide_extended_parameters'),
        container = $('.widget_product_params.normal')
        ;
    if (showLink.length) {
        showLink.on('click', onShowClick);
    }
    if (hideLink.length) {
        hideLink.on('click', onHideClick);
    }

    if ($('.parameters-extend-links').length) {
        //$('.parameters-extend-links').plug(Y.Plugin.ScrollNav);
    }
    function onShowClick(e) {
        var
            el = $(e.currentTarget),
            categoryId = el.attr('data-category_id')
            ;
        container.find('.hidden')
            .addClass('to-hidden')
            .removeClass('hidden');
        //cookieConfig.Parameter.setShowExtended(categoryId, true);
        el.hide();
    }

    function onHideClick(e) {
        var
            el = $(e.currentTarget),
            categoryId = el.attr('data-category_id')
            ;
        container.find('.to-hidden')
            .addClass('hidden')
            .removeClass('to-hidden');
        //cookieConfig.Parameter.setShowExtended(categoryId, false);
        el.hide();
        //$('#toTop')[0].click();
    }
}

function showLayer(pTarget) {
    var node = defineNode(pTarget);
    if (node.css('visibility') == 'hidden') {
        node.attr('useVisibility', 'ja');
        node.css('visibility', 'visible');
    } else {
        node.css('opacity', '0');
        node.show(true);
        if (node.css('position') == 'absolute' || node.css('position') == 'fixed') {
            if ($(window).attr('winHeight') - $(window).attr('scrollY') > node.getY()) {
                $(window).attr('scrollTop', $(window).attr('winHeight') - $(window).attr('scrollY') + 20);
            }
        }
    }
}
function hideLayer(pTarget) {
    var node = defineNode(pTarget);
    if (node.hasAttr('useVisibility')) {
        node.css('visibility', 'hidden');
    } else {
        node.hide(true);
    }
}

Parameters.prototype.fnParametersSubmit = function (e) {
    var p = new Array();
    var p_str = '';
    var p_name = new Array();
    var p_name_str = '';
    var parameters = new Array;
    var parameter_to_values = new Array;
    var parameters_name = new Array;
    var parameter_name_to_values_name = new Array;
    var nodeForm = $('#f_parameters');


    $('.widget_product_params input:checked').each(function (i, nodeINPUT) {
        nodeINPUT = $(nodeINPUT);
        var nodeINPUTDom = nodeINPUT[0];
        if (nodeINPUTDom.checked) {
            var parameter_id = nodeINPUT.attr('data-parameter_id');
            var parameter_name_in_category = nodeINPUT.attr('data-parameter_name_in_category_translit');
            var parameter_value_name = nodeINPUT.attr('data-parameter_value_name_translit');
            if (!phpjs.in_array(parameter_id, parameters)) {
                parameters.push(parameter_id);
            }
            if (parameter_to_values[parameter_id] == undefined) {
                parameter_to_values[parameter_id] = new Array();
            }
            parameter_to_values[parameter_id].push(nodeINPUT.attr('value'));
            if (!phpjs.in_array(parameter_name_in_category, parameters_name)) {
                parameters_name.push(parameter_name_in_category);
            }
            if (parameter_name_to_values_name[parameter_name_in_category] == undefined) {
                parameter_name_to_values_name[parameter_name_in_category] = new Array();
            }
            parameter_name_to_values_name[parameter_name_in_category].push(parameter_value_name);
        }
    });
    for (var i = 0; i < parameters.length; i++) {
        p_str += parameters[i] + '_';
        p_str += phpjs.implode('.', parameter_to_values[parameters[i]]) + '_';
        p.push({parameter_id: parameters[i], values: parameter_to_values[parameters[i]]});
        p_name_str += parameters_name[i] + '_';
        p_name_str += phpjs.implode(',', parameter_name_to_values_name[parameters_name[i]]) + ';';
    }
//    $('#i_p_name').attr('value', p_name_str);
    var href = nodeForm.attr('data-action_origin') + ((p_name_str) ? '?p_name=' + p_name_str : '?p_name=');
    if ($('#i_url_params_pre_page').length) {
        var url_params_pre_page = parseInt($('#i_url_params_pre_page').attr('value'));
        if (url_params_pre_page > 0) {
            $('#i_pre_page').attr('name', 'pre_page');
            $('#i_pre_page').attr('value', url_params_pre_page);
            href += '&pre_page=' + url_params_pre_page;
        }
    }
    var nodeA = $('<a href="' + href + '"></a>');
    $('body').append(nodeA);
    nodeA[0].click();
};
var parameters_selected = false;
var ajax_cross_sample_timout_int;
var object_for_ajax_parameter_cross_sample;
function fnParametersHiddingSeoLinks() {
    $('.parameters-seo-link-for-hidden').each(function (i, el) {
        el = $(el);
        el[0].outerHTML = el.html();
    });
};
function fnParametersOnClickLabel(ev) {
//        if ($('.b_show').css('display') == 'none') {
//            $('.b_show').show(true);
//        }
//    ev.stopPropagation();
//    ev.preventDefault();
    var self = this;
    window.setTimeout(function () {
        if ($('.a_ochistit').css('display') == 'none') {
            $('.a_ochistit').show();
        }
        clearTimeout(ajax_cross_sample_timout_int);
        object_for_ajax_parameter_cross_sample = self;
        ajaxParametersCrossSample(object_for_ajax_parameter_cross_sample, that_product_id);
    }, 150);
};
var that_product_id;
function fnParametersApplyEventNodeInputsClick(nodeInput) {
    if ($('#i_product_is_common').length) {
        $('#f_parameters').attr('data-action', $('#f_parameters').attr('data-request_uri'))
            .attr('data-action_origin', $('#f_parameters').attr('data-request_uri'));
        that_product_id = $('#i_product_id').attr('value');
    }
    nodeInput.on('click', fnParametersOnClickLabel);
    var nodeInputDOM = nodeInput[0];
    if (nodeInputDOM.checked) {
        parameters_selected = true
    }
    fnParametersHiddingSeoLinks();
};
function fnParametersApplyClickEventForBShowButton() {
//    $('.b_show').each(function (i, el) {
//    el = $(el);
//        el.detach('click');
//        el.on('click', function (e) {
//            fnParametersSubmit(e);
////            $('#f_parameters').submit();
//            _gaq.push(['_trackEvent','parameters','show']);
//        })
//    });
};
function fnParametersApplyForSeoUrlClickEventForBShowButton(nodeASeo_id) {
//    $('.b_show').each(function (i, el) {
//    el = $(el);
//        el.detach('click');
//        el.on('click', function (e) {
//            $('#' + nodeASeo_id)[0].click();
//        })
//    });
};
function fnParametersPokazatVseClick(parameter_id, show_all, linked_parameter_values) {
    var
        category_id = $('#f_parameters').attr('data-category_id'),
        selected_parameter_values = {0: []},
        i = 0,
        nodeParameter = $('#parameter_' + parameter_id),
        dimmer = nodeParameter.find('.dimmer')
        ;
    if (!dimmer.length) {
        nodeParameter.find('ul').css({
            position: 'relative'
        });
        dimmer = $('<div class="ui inverted dimmer"><div class="ui loader"></div></div>');
        nodeParameter.find('ul').prepend(dimmer);
        //nodeParameter.find('ul').addClass('ui');
        //nodeParameter.find('ul').addClass('form');
    }
    dimmer.addClass('active');
    nodeParameter.addClass('parameter-scrolling');
    nodeParameter.find('input').each(function (i, el) {
        el = $(el);
        if (el[0].checked) {
            selected_parameter_values[0][i] = el.attr('value');
            i++;
        }
    });
    linked_parameter_values = (linked_parameter_values !== undefined ? $.makeArray(linked_parameter_values) : 0);
    $.ajax('index.php?route=module/parameterValueList&is_ajax=1',
        {
            data: {
                category_id: category_id,
                parameter_id: parameter_id,
                show_all: 1,
                linked_parameter_values: linked_parameter_values,
                selected_parameter_values: $.makeArray(selected_parameter_values)
            },
            complete: function (o, statusText) {
                dimmer.removeClass('active');
                $('#ul_parameter_' + parameter_id).html(o.responseText);
                //Core.setupCustomInputs();
                $('#ul_parameter_' + parameter_id).find('li').each(function (i, nodeLI) {
                    nodeLI = $(nodeLI);
                    if (!nodeLI.hasClass('exited')) {
                        nodeLI.show();
                    }
                    fnParametersApplyEventNodeInputsClick(nodeLI.find('input'));
                });
                fnParametersGrayIfNotExists();
            }
        });
};
var checkedParameterToParameterValues = [];
function saveCheckedParameters() {
    var nodeListParameterValueInput = $('input[type=checkbox].parameters');
    nodeListParameterValueInput.each(function (i, el) {
        el = $(el);
        if (el[0].checked) {
            if (!array_key_exists(el.attr('data-parameter_id'), checkedParameterToParameterValues)) {
                checkedParameterToParameterValues[el.attr('data-parameter_id')] = [];
            }
            checkedParameterToParameterValues[el.attr('data-parameter_id')].push(el.attr('value'));
        }
    })
};
function restoreCheckedParameters() {
    for (var parameter_id in checkedParameterToParameterValues) {
        $('#parameter_' + parameter_id).each(function (i, el) {
            el = $(el);
            el.find('input').each(function (i, elNodeInput) {
                elNodeInput = $(elNodeInput);
                if (phpjs.in_array(elNodeInput.attr('value'), checkedParameterToParameterValues[parameter_id])) {
                    elNodeInput[0].checked = true;
                }
            });
        })
    }
};

function fnParametersExtendedClick() {
    var category_id = $('#f_parameters').attr('data-category_id');
    var autofilling = $('#f_parameters').attr('data-autofilling');
    //Y.Cookie.setSub(Y.MyApp.Inner.COOKIE_SUB_PARAMETERS, 'show_parameters_extended_' + category_id, '1');
    $('div.parameters-extended-link').css('visibility', 'hidden');
    saveCheckedParameters();
    $.ajax('index.php?route=module/parameterList&is_ajax=1',
        {
            data: {
                category_id: category_id,
                autofilling: autofilling
            },
            complete: function (o, statusText) {
                $('.widget.widget-slider.widget_product_params').html(o.responseText);
                $('div.parameters-extended-link').hide();
                $('div.parameters-extended-link-down').show();
                $('.a_pokazat_vse').each(function (i, elA) {
                    elA = $(elA);
                    elA.on('click', function () {
                        fnParametersPokazatVseClick($(this).attr('data-parameter_id'), 1)
                    });
                });
                $('.widget-content.parameter label input').each(function (i, nodeInput) {
                    nodeInput = $(nodeInput);
                    fnParametersApplyEventNodeInputsClick(nodeInput);
                });
                restoreCheckedParameters();
                fnParametersHiddingSeoLinks();
            }
        });
};

function fnParametersExtendedDownClick() {
    var category_id = $('#f_parameters').attr('data-category_id');
    $('.parameter.extended').each(function (i, nodeDIV) {
        nodeDIV = $(nodeDIV);
        nodeDIV.css('opacity', '1');
        nodeDIV.hide(true);
    });
    $('div.parameters-extended-link-down').hide();
    //Y.Cookie.removeSub(Y.MyApp.Inner.COOKIE_SUB_PARAMETERS, 'show_parameters_extended_' + category_id);
    $('DIV.parameter-group-name.visibled').addClass('hidden').removeClass('visibled');
    $('DIV.parameter-group-name-empty.visibled').addClass('hidden').removeClass('visibled');
    $('div.parameters-extended-link').css('visibility', 'visible').show();
    //document.location.replace('#parameters_home');
};

function fnParametersGrayIfNotExists() {
    if (parametersLastJSONResponse !== undefined) {
        var values_from_other_groups_not_check = true;
        var countVisibleElementsPerParameter = null;
        var parameter_value_exists = false;
        var response_json_parameters_exists_is_object = parametersLastJSONResponse.parameters_exists.length;
        $('.widget-content.parameter label input').each(function (i, nodeInput) {
            nodeInput = $(nodeInput);
            nodeInput.parents('label').css('color', '#979797');
            if (response_json_parameters_exists_is_object) {
                if (phpjs.in_array(nodeInput.attr('value'), parametersLastJSONResponse.parameters_exists)) {
                    nodeInput.parents('label').css('color', '#000000');
                    parameter_value_exists = true;
                }
            }
        });
        var groups_to_be_updated = new Array();
        $('.widget-content.parameter label input').each(function (i, nodeInput) {
            nodeInput = $(nodeInput);
            group_key = 'parameter_' + nodeInput.attr('data-parameter_id');
            if (!phpjs.in_array(group_key, groups_to_be_updated)) {
                groups_to_be_updated.push(group_key);
            }
        });
        for (var i = 0; i < groups_to_be_updated.length; i++) {
            var group_key = groups_to_be_updated[i];
            if (typeof parametersLastJSONResponse[group_key] != 'undefined' && parametersLastJSONResponse[group_key].length) {
                var parameters_for_group = parametersLastJSONResponse[group_key];
                $('.widget-content.parameter label input').each(function (i, nodeInput) {
                    nodeInput = $(nodeInput);
                    if (group_key == 'parameter_' + nodeInput.attr('data-parameter_id')) {
                        var nodeSpan = nodeInput.parents('label');
                        if (parameters_for_group.length > 0) {
                            for (var j = parameters_for_group.length - 1; j >= 0; --j) {
                                var parameter_value_id = parameters_for_group[j];
                                if (parameter_value_id == nodeInput.attr('value')) {
                                    nodeSpan.css('color', '#000000');
                                }
                            }
                        }
                    }
                });
            }
        }
    }
};

var responseText;
var showerTimer;
var node;
var nodeID;
var lastChangedParameterId;
var nodeASeo_id;
var isActivatedParametersLinked = false;
var previousParametersLinked = {};
function fnCompleteParametersCrossSample() {
    var key,
        parameter_id_in_response;
    if (parametersLastJSONResponse != undefined) {

        if (parametersLastJSONResponse.parameter_value_id_list_by_linked_parameter_values.length == undefined) {
            for (var parameter_id in parametersLastJSONResponse.parameter_value_id_list_by_linked_parameter_values) {
                if (lastChangedParameterId != parameter_id) {
                    fnParametersPokazatVseClick(parameter_id, 1, parametersLastJSONResponse.parameter_value_id_list_by_linked_parameter_values);
                    isActivatedParametersLinked = true;
                    if (previousParametersLinked[lastChangedParameterId]) {
                        for (key in previousParametersLinked[lastChangedParameterId]) {
                            if (typeof(parametersLastJSONResponse.parameter_value_id_list_by_linked_parameter_values[previousParametersLinked[lastChangedParameterId][key]]) == 'undefined') {
                                fnParametersPokazatVseClick(previousParametersLinked[lastChangedParameterId][key], 0);
                            }
                        }
                    }
                    previousParametersLinked[lastChangedParameterId] = [];
                    for (parameter_id_in_response in parametersLastJSONResponse.parameter_value_id_list_by_linked_parameter_values) {
                        previousParametersLinked[lastChangedParameterId].push(parameter_id_in_response);
                    }
                }
            }
        } else {
            if (isActivatedParametersLinked) {
                if ((!parametersLastJSONResponse['parameter_' + lastChangedParameterId] || parametersLastJSONResponse['is_all_parameters'])
                    && previousParametersLinked[lastChangedParameterId]
                ) {
                    for (key in previousParametersLinked[lastChangedParameterId]) {
                        fnParametersPokazatVseClick(previousParametersLinked[lastChangedParameterId][key], 0);
                    }
                }
            }
        }

        fnParametersGrayIfNotExists();
    }
};
function fnCompleteParametersCrossSampleGetTotal() {
    if (parametersLastJSONResponseGetTotal != undefined) {
        if (node != null) {
            if ($('.product-total-popup').length) {
                $('.product-total-popup').remove();
            }
            var nodeDIV = $('<div />');
            nodeDIV.css({
                zIndex: 201,
                backgroundColor: '#EBEBF5',
                border: '1px solid #C2C2ED',
                opacity: '0',
                position: 'absolute',
                padding: '5px',
                textAlign: 'center',
                transform: 'translateX(-110%) translateY(-65%)',
                borderRadius: '10px'
            });
            nodeDIV.html('Отобрано:&nbsp;' + parametersLastJSONResponseGetTotal.product_total + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="javascript:;" onclick="$(this).parents(\'div\').remove();"><i class="close basic icon" style="position: absolute;right: 0px"></i></a><br>');
            nodeDIV.addClass('product-total-popup');
            if (parseInt(parametersLastJSONResponseGetTotal.product_total) > 0) {
                var nodeA = $('<a href="javascript:;" />');
                var nodeFORM = $('#f_parameters');
                if (parametersLastJSONResponseGetTotal.seo_url) {
                    nodeA.attr('href', '/' + parametersLastJSONResponseGetTotal.seo_url);
                    nodeASeo_id = nodeA.generateID();
                    nodeFORM.attr('action', nodeA.attr('href'));
                    fnParametersApplyForSeoUrlClickEventForBShowButton(nodeASeo_id);
                } else {
                    nodeA.on('click', function (e) {
                        Parameters.prototype.fnParametersSubmit(e);
//                        $('#f_parameters').submit();
                        _gaq.push(['_trackEvent', 'parameters', 'show']);
                    });
                    nodeFORM.attr('action', nodeFORM.attr('data-action_origin'));
                    fnParametersApplyClickEventForBShowButton();
                }
                nodeA.html('Показать');
                nodeDIV.append(nodeA);
//                $('.b_show').each(function(el){el[0].disabled = false;});
//                if ($('#a_pokazat').css('display') == 'none') {
//                    showLayer($('#a_pokazat'));
//                }
            } else {
                //$('.b_show').each(function(el){el[0].disabled = true;});
                //hideLayer($('#a_pokazat'));
            }
            nodeDIV.addClass('shower');
            var nodeInput = node;
//            var nodeTD = Y.one('#td_parameter_value_' + nodeInput.attr('value'));
//            if (nodeInput.parents('.li').attr('data-autofilling') == 1) {
            //nodeDIV.css('marginLeft', '-280px');
//            }
//            if (!Y.UA.gecko) {
//                nodeDIV.css('marginTop', parseInt(nodeDIV.css('marginTop')) - parseInt(nodeInput.parents('ul').attr('scrollTop')) + 'px');
            //}
            nodeInput.parents('li').append(nodeDIV);
            clearTimeout(showerTimer);
            var
                xy = [nodeDIV.offset().left, nodeDIV.offset().top],
            styles = {
                top: parseInt(xy[1]) + 'px',
                display: 'none',
                transform: 'none'
            }
            ;
            if ($('body').data('isMobile')) {
                styles.right = '5px';
            } else {
                styles.left = parseInt(xy[0]) + 'px';
            }
            nodeDIV.css(styles);
            nodeDIV.css('opacity', 1);
            nodeDIV.css('display', 'none');
            $('body').append(nodeDIV);
            nodeDIV.show();
        }
    }
};
var parametersLastJSONResponse;
var parametersLastJSONResponseGetTotal;
function ajaxParametersCrossSample(pTarget, that_product_id) {
    var mappe = 'module';
    var datei = 'parametersCrossSample';
    node = defineNode(pTarget);
    nodeID = null;
    if (node != null) {
        if (node.attr('tagName') == 'INPUT') {
            nodeID = node.generateID();
        } else {
            nodeID = node.find('input').generateID();
        }
        lastChangedParameterId = node.attr('data-parameter_id');
    }
    var p_str = '';
    var category_id = $('#f_parameters').attr('data-category_id');
    var params = 'category_id=' + category_id;
    var parameters = new Array;
    var parameters_to_values = new Array();
    $('.widget.widget-slider.widget_product_params input:checked').each(function (i, nodeInput) {
        nodeInput = $(nodeInput);
        var nodeInputDOM = nodeInput[0];
        if (nodeInputDOM.checked) {
            var parameter_id = nodeInput.attr('data-parameter_id');
            if (!phpjs.in_array(parameter_id, parameters)) {
                parameters.push(parameter_id);
            }
            if (parameters_to_values[parameter_id] == undefined) {
                parameters_to_values[parameter_id] = new Array;
            }
            parameters_to_values[parameter_id].push(nodeInput.attr('value'));
        }
    });
    for (var i = 0; i < parameters.length; i++) {
        var parameter_id = parameters[i];
        p_str += parameter_id + '_';
        p_str += phpjs.implode('.', parameters_to_values[parameter_id]) + '_';
    }
    if (typeof(that_product_id) == 'undefined') {
        that_product_id = 0;
    }
    params += '&p=' + p_str + '&that_product_id=' + that_product_id;
    var page = $('#i_page_for_crossSample').attr('value');
    params += '&page=' + page;
    var uri = '/index.php?route=' + mappe + '/' + datei + 'GetTotal';
    var cfg = {
        method: 'GET',
        data: params,
        complete: function (o, statusText) {
            if (!phpjs.empty(o.responseJSON)) {
                try {
                    parametersLastJSONResponseGetTotal = o.responseJSON.data;
                    if (typeof(parametersLastJSONResponseGetTotal.that_product_id_in_results_is_exists) != 'undefined') {
                        if (!parametersLastJSONResponseGetTotal.that_product_id_in_results_is_exists) {
                            $('#f_parameters').attr('data-action', $('#f_parameters').attr('data-action_default'));
                            $('#f_parameters').attr('data-action_origin', $('#f_parameters').attr('data-action_default'));
                        } else {
                            $('#f_parameters').attr('data-action', $('#f_parameters').attr('data-request_uri'));
                            $('#f_parameters').attr('data-action_origin', $('#f_parameters').attr('data-request_uri'));
                        }
                    }
                }
                catch (e) {
                    //alert('Invalid JSON-data:' + o.responseText);
                }
            }
            fnCompleteParametersCrossSampleGetTotal();

            var uri = '/index.php?route=' + mappe + '/' + datei;
            var cfg = {
                method: 'GET',
                data: params,
                complete: function (o, statusText) {
                    if (!phpjs.empty(o.responseJSON)) {
                        try {
                            parametersLastJSONResponse = o.responseJSON.data;
                            if (typeof(parametersLastJSONResponse.that_product_id_in_results_is_exists) != 'undefined') {
                                if (!parametersLastJSONResponse.that_product_id_in_results_is_exists) {
                                    $('#f_parameters').attr('data-action', $('#f_parameters').attr('data-action_default'));
                                    $('#f_parameters').attr('data-action_origin', $('#f_parameters').attr('data-action_default'));
                                } else {
                                    $('#f_parameters').attr('data-action', $('#f_parameters').attr('data-request_uri'));
                                    $('#f_parameters').attr('data-action_origin', $('#f_parameters').attr('data-request_uri'));
                                }
                            }
                        }
                        catch (e) {
                            //alert('Invalid JSON-data:' + o.responseText);
                        }
                    }
                    fnCompleteParametersCrossSample();
                }
            };
            var request = $.ajax(uri, cfg);
            request = null;
        }
    };
    var request = $.ajax(uri, cfg);
    request = null;


}

function defineNode(pTarget) {
    var id;
    switch (typeof(pTarget)) {
        case 'string':
            id = (pTarget.indexOf('#') === 0) ? pTarget : '#' + pTarget;
            break;
        case 'object':
            if (pTarget != null) {
                pTarget = $(pTarget);
                pTarget.generateID();
                id = pTarget.attr('id');
                id = (id.indexOf('#') === 0) ? id : '#' + id;
            } else {
                return null;
            }
            break;
        default:
            return null;
            break;
    }
    var node = $(id);
    return node;
};

module.exports = new Parameters();


// WEBPACK FOOTER //
// ./assets/javascript/parameters.js